export default __webpack_public_path__ + "static/media/user-pics-8.d640b2ad.png";